// extracted by mini-css-extract-plugin
export var button = "_er-4";
export var hasDarkBackground = "_er-7";
export var hasLightBackground = "_er-6";
export var iconWrapper = "_er-0";
export var large = "_er-2";
export var medium = "_er-1";
export var small = "_er-5";
export var xsmall = "_er-3";